import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home'
import Price from '@/pages/price'
import Contact from '@/pages/contact'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    }, {
      path: '/price',
      name: 'price',
      component: Price
    }, {
      path: '/contact',
      name: 'contact',
      component: Contact
    }
  ],
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js